import { WatchQueryFetchPolicy } from '@apollo/client/core/watchQueryOptions'
import { useMutation } from '@apollo/client/react/hooks/useMutation'
import { useQuery } from '@apollo/client/react/hooks/useQuery'
import { CREATE_CLUSTER } from './createCluster'
import { CREATE_CLUSTER_STATUS } from './createClusterStatus'
import { DELETE_CLUSTER } from './deleteCluster'
import { DELETE_CLUSTER_STATUS } from './deleteClusterStatus'
import { GET_CLUSTER_ASSORTMENT } from './getClusterAssortment'
import { UPDATE_CLUSTER } from './updateCluster'
import { UPDATE_CLUSTER_STATUS } from './updateClusterStatus'
import map from 'lodash/map'
import sortBy from 'lodash/sortBy'
import { useEffect, useState } from 'react'
import { getClusters } from '@services/clusterSettingServices'

export interface ICluster {
  Id?: string
  Name?: string
  RGBHex?: string
  channel?: string
  colorHex?: string
  clusterId?: string
}

export interface IClusterStatus {
  Id?: string
  name?: string
  channel?: string
  clusterStatusId?: string
}

export const useClusters = (channelId?: string) => {
  const [clusters, setClusters] = useState(null)
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true)
        const response = await getClusters(channelId).then(clustersList =>
          map(sortBy(clustersList, 'order'), cluster => ({
            Id: cluster.id,
            Channel: cluster.channelId,
            Name: cluster.name,
            RGBHex: cluster.rgbHex,
            VIPSortOrder: cluster.order
          }))
        )

        setClusters(response)

        setLoading(false)
      } catch (error) {
        setError(error)
        setLoading(false)
      }
    }
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channelId])
  return {
    clusters,
    loading,
    error
  }
}

export const useQueryGetClusterAssortment = (
  buyingSessionId: string,
  fetchPolicy: WatchQueryFetchPolicy = 'cache-first'
) => {
  const { loading, data: clusterAssortMentData } = useQuery(GET_CLUSTER_ASSORTMENT, {
    skip: !buyingSessionId,
    variables: {
      buyingSessionId
    },
    fetchPolicy
  })
  return {
    items: clusterAssortMentData?.findVIPClusterAssortment?.Items || [],
    loading
  }
}

export const useCreateCluster = () => {
  const [ref] = useMutation(CREATE_CLUSTER)
  return ref
}

export const useDeleteCluster = () => {
  const [ref] = useMutation(DELETE_CLUSTER)
  return ref
}

export const useUpdateCluster = () => {
  const [ref] = useMutation(UPDATE_CLUSTER)
  return ref
}

export const useCreateClusterStatus = () => {
  const [ref] = useMutation(CREATE_CLUSTER_STATUS)
  return ref
}

export const useUpdateClusterStatus = () => {
  const [ref] = useMutation(UPDATE_CLUSTER_STATUS)
  return ref
}

export const useDeleteClusterStatus = () => {
  const [ref] = useMutation(DELETE_CLUSTER_STATUS)
  return ref
}
